import LabelText from "@/components/label-text/label-text.vue";
import { ReportsLocale } from "@/locales/localeid";
import { ReportsModule } from "@/modules/reports-objective";
import { Checkbox, Select } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { cloneDeep } from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ComponentData, LevelData } from "../component-objective-header-actions/component-objective-header-actions";

@Component({
	components: {
		Checkbox,
		Select,
		Option: Select.Option,
		LabelText
	}
})
export default class CommonHeader extends Vue {
	@Prop() showLevel4Checkbox?: boolean;
	@Prop({ default: [] }) components!: [] | never[];
	@Prop({ default: null }) selectedContentId!: string;
	@Prop() setSelectedContent!: Function;
	@Prop() availableLevels!: [];
	@Prop() selectedLevel!: number;
	@Prop() setSelectedLevel!: Function;
	@Prop({ default: null }) selectedObjectiveId!: string;
	@Prop() setSelectedObjective!: Function;
	@Prop() setComponents!: Function;
	@Prop({ default: false }) isComponentDropdownLoading!: boolean;
	@Prop({ default: false }) isObjectiveFilterDropdownLoading!: boolean;
	@Prop() level1Data!: [];
	@Prop() level2Data!: [];
	@Prop() level3Data!: [];
	@Prop() level4Data?: [];
	@Prop({ default: [] }) objectivesData!: [];
	public filteredComponents: ComponentData[] = this.components;
	public filteredObjectives: LevelData[] = [];

	@Watch("components")
	updateFilteredComponents() {
		this.filteredComponents = cloneDeep(this.components);
	}

	@Watch("objectivesData")
	updateFilteredObjectives() {
		this.filteredObjectives = cloneDeep(this.objectivesData);
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	handleLevelChange(value) {
		this.setSelectedObjective("null");
		this.setSelectedLevel(value);
	}

	get reportsLocale() {
		return ReportsLocale;
	}

	get isLevel4Checked() {
		return ReportsModule.isLevel4Checked;
	}

	onCheckboxChange(value) {
		ReportsModule.setIsLevel4Checked(value.target.checked);
	}

	handleComponentChange(value) {
		this.setSelectedObjective("null");
		this.setSelectedContent(value);
	}

	handleComponentSearch(value) {
		this.filteredComponents = this.components.filter((component: any) => {
			return component.contentName.toLowerCase().includes(value.toLowerCase());
		});
	}

	handleObjectiveChange(value) {
		this.setSelectedObjective(value);
	}
	handleObjectiveSearch(value) {
		this.filteredObjectives = this.objectivesData.filter((objective: any) => {
			return objective.pureText.toLowerCase().includes(value.toLowerCase());
		});
	}

	getObjectiveText(objective) {
		return objective.text;
	}

	getObjectiveTitleText(objective) {
		return objective.pureText;
	}
}
